import React, { Fragment, useEffect } from 'react'
import injectSheet from 'react-jss'
import styles from './profile.styles'
import Paper from 'pobble-components/dist/paper'
import Spinner from 'pobble-components/dist/spinner'
import General from './general/general.container'
import Email from './email/email.container'
import Password from './password/password.container'
import Newsletter from './newsletter/newsletter.container'
import Avatar from './avatar/avatar.container'
import Permissions from './permissions/permissions.container'
import School from './school/school.container'
import StudentAvatar from './student-avatar/student-avatar.container'
import StudentDisplayName from './student-displayname/student-displayname.container'
import Oauth from './oauth/oauth.container'

const useDynamicAnchor = (trigger, delay = 0) => {
  // https://stackoverflow.com/a/43168456/4882422
  useEffect(
    () => {
      let tm = null
      if (trigger) {
        tm = setTimeout(() => {
          const requestedHash = window.location.hash.slice(1)
          window.location.hash = ''
          window.location.hash = requestedHash
        }, delay)
      }
      return () => {
        clearTimeout(tm)
      }
    },
    [trigger, delay]
  )
}

const Profile = ({
  classes,
  pending,
  isStudent,
  canUpdateEmail,
  canUpdatePassword,
  onMount
}) => {
  useEffect(() => {
    onMount()
  }, []) // eslint-disable-line

  useDynamicAnchor(!pending, 200)

  return (
    <Fragment>
      {!pending && (
        <Fragment>
          {isStudent && (
            <Fragment>
              <StudentAvatar />
              <StudentDisplayName />
            </Fragment>
          )}
          {!isStudent && (
            <Paper className={classes.container}>
              <Avatar />
              <General />
              {canUpdateEmail && <Email />}
              {canUpdatePassword && <Password />}
              <Oauth />
              <Newsletter />
              <Permissions />
              <School />
            </Paper>
          )}
        </Fragment>
      )}
      {pending && <Spinner className={classes.spinner} />}
    </Fragment>
  )
}

export default injectSheet(styles)(Profile)
